export default "/images/global-min.avif?638d28ca8d5c511ab575d94478e60600";